import {
  AUTH_ON_CHANGE,
  AUTH_ON_LOGIN,
  AUTH_ON_LOGIN_ERROR,
  AUTH_ON_LOGIN_SUCCESS,
  AUTH_ON_LOGOUT,
  ANALYTICS_INITIAL_STATE,
  PAGE_LOADING
} from "../../constants/types";
import { push } from "react-router-redux";
import axios from "axios";
import Token from "../../helpers/token";
import { getUrl, BASE_URL } from "../../constants/constants";

export const authOnInit = () => {
  return dispatch => {
    return new Promise((resolve, reject) => {
      Token.checkIfValid().then(
        response => {
          if (response.status === 200) {
            const url = window.location.pathname;
            dispatch({ type: AUTH_ON_LOGIN_SUCCESS, payload: response.data });
            dispatch(push(url));
            resolve(response);
          } else {
            reject(response);
            dispatch(push("/login"));
          }
        },
        error => {
          reject(error);
          dispatch(push("/login"));
        }
      );
    });
  };
};

export const authOnLogin = ({ email, password, captchaVal }) => {
  return dispatch => {
    dispatch({
      type: AUTH_ON_LOGIN,
      payload: { email, password, captchaVal }
    });

    console.log("Have it in capchaVAL", captchaVal)
    axios.defaults.headers.common['Authorization'] = ''
    return axios
      .post("api/login/", {
        email: email,
        password: password,
        request_type: 'analytics',
        'g-recaptcha-response': captchaVal
      })
      .then(
        response => {
          dispatch({ type: AUTH_ON_LOGIN_SUCCESS });
          Token.set(response.data.token);

          localStorage.setItem("TimeRange", response.data.time_range)
          let url = getUrl(response.data.type, response.data.user_type);
          // window.location.href=url
          dispatch(push(url));
        },
        error => {

          console.log("ERROR is: ", error)
          dispatch({
            type: AUTH_ON_LOGIN_ERROR,
            payload: { errors: ["Wrong credentials"] }

          });
        }
      ).catch((e) => {
        console.log("ERROR is: ", e)
      });
  };
};

export const authOnLogout = () => {

  return dispatch => {

    let token = localStorage.getItem('token')

    if (token) {
      axios.defaults.headers.common['Authorization'] = token

      console.log(axios.defaults.headers.common)
      console.log(axios.defaults.headers.common['Authorization'])

      axios.post(`${BASE_URL}api/logout/`, {

      })
        .then(function (response) {
          console.log("Logout is:", response)
          localStorage.removeItem("TimeRange")
          Token.remove();
          console.log(Token)
          dispatch({ type: AUTH_ON_LOGOUT });
          dispatch({ type: ANALYTICS_INITIAL_STATE });
          dispatch(push("/login"));
        })
        .catch(function (error) {
          Token.remove();
          dispatch({ type: AUTH_ON_LOGOUT });
          dispatch({ type: ANALYTICS_INITIAL_STATE });
          dispatch(push("/login"));
        });

    }
    // return axios.get('api/me/')





    // Call logout API here, in Request, .then will perform the below actions

  };


};

export const authOnChange = (key, value) => {
  return {
    type: AUTH_ON_CHANGE,
    payload: { key, value }
  };
};



// WEBPACK FOOTER //
// ./src/modules/auth/AuthActions.js